import React, { useCallback } from 'react';
import {useLocalI18n} from '../../../../../../data/hooks/i18nHooks';
import strings from '../../BubblesFilter/BubblesFilter.i18n.csv';
import ActiveFilterButton from '../ActiveFilterButton/ActiveFilterButton';

const InnerFilter = props => {
    const {event, filterParams} = props,
        i18n = useLocalI18n(strings),
        active = !!filterParams?.connections;

    const handleClick = useCallback(
        () =>
            app.store.dispatch(
                app.actions.participants.setFilterParams(event.id, {
                    ...(filterParams || {}),
                    connections: null,
                })
            ),
        [filterParams]
    );

    return (
        <ActiveFilterButton event={event} onClick={handleClick} visible={active}>
            {i18n['inner-circle']}
        </ActiveFilterButton>
    );
};

export default InnerFilter;
